import {AscDesc, GenericService, Result, ResultType} from '@/shared/xhttp';
import {Logement} from "@/models";
import caller from "@/shared/caller";

export class LogementService extends GenericService<Logement> {
}
